export default __webpack_public_path__ + "static/banner-4-0ea43bba780ceb0d211870c2f0e160e9.jpg";